__turbopack_context__.v({
  "breadcrumb": "elements-module-sass-module__4VDB_W__breadcrumb",
  "dividerHorizontal": "elements-module-sass-module__4VDB_W__dividerHorizontal",
  "dividerVertical": "elements-module-sass-module__4VDB_W__dividerVertical",
  "key": "elements-module-sass-module__4VDB_W__key",
  "rotation": "elements-module-sass-module__4VDB_W__rotation",
  "spinner": "elements-module-sass-module__4VDB_W__spinner",
  "themeDependent": "elements-module-sass-module__4VDB_W__themeDependent",
  "themeDependentAndBright": "elements-module-sass-module__4VDB_W__themeDependentAndBright",
});
